(function() {
    const allItemsWithExtra = function() {
        let items = baItems;
        
        if(document.querySelector('.js-extra-item-list')) {
            const extraItemsContainers = document.querySelectorAll('.js-extra-item-list');
            for (let index = 0; index < extraItemsContainers.length; index++) {
                const extraItemsContainer = extraItemsContainers[index];
                const extra_items = extraItemsContainer.querySelectorAll('[data-item-data]');
                if(extra_items.length) {
                    for (let items_index = 0; items_index < extra_items.length; items_index++) {
                        const item = extra_items[items_index];
                        items.push(JSON.parse(item.dataset.itemData));
                    }
                }
            }
        }
        return items;
    }

    /* Get all dem elements */
    const ageFilter = document.querySelector('#AgeFilter');
    const genderFilter = document.querySelector('#GenderFilter');
    const hairTypeFilter = document.querySelector('#HairTypeFilter');
    const allItems = allItemsWithExtra();
    const itemListElement = document.querySelector('.js-item-list');
    const resultsElement = document.querySelector('.js-results');
    const loadMoreElement = document.querySelector('.js-load-more');
    const progressBarElement = document.querySelector('.js-progress-bar');
    const amountShownElement = document.querySelector('.js-amount-shown');
    const totalAmountElement = document.querySelector('.js-total-amount');
    const popupElement = document.querySelector('.js-popup');
    const popupClose = document.querySelector('.js-close');
    const overlay = document.querySelector('.js-overlay');
    const resetFilter = document.querySelector('.js-reset-filter');
    let currentItemArray = allItems;

    /* Eventlisteners to make it all work */
    resetFilter.addEventListener('click', () => {
        if (ageFilter.value == '*' && genderFilter.value == '*' && hairTypeFilter.value == '*') return;
        ageFilter.value = '*';
        genderFilter.value = '*';
        hairTypeFilter.value = '*';

        filterItems();
    });

    ageFilter.addEventListener('change', () => {
        filterItems();
    });

    genderFilter.addEventListener('change', () => {
        filterItems();
    });

    hairTypeFilter.addEventListener('change', () => {
        filterItems();
    });

    overlay.addEventListener('click', () => {
        deactivePopup();
    });

    popupClose.addEventListener('click', () => {
        deactivePopup();
    });

    loadMoreElement.addEventListener('click', () => {
        const amountOfItemsCurrentlyLoaded = itemListElement.querySelectorAll('.ba__list__item').length;

        for (let i = amountOfItemsCurrentlyLoaded; i < amountOfItemsCurrentlyLoaded + 9; i++) {
            if (i == currentItemArray.length) {
                loadMoreElement.classList.add('hidden');
                break;
            }
            setupEventListenerForItem(currentItemArray[i], itemListElement)
        }
        updateProgressBar();
        updateAmountShownElement();
    });

    /* Functions to give functionality (great description i know) */
    const filterItems = () => {
        const ageVal = ageFilter.value;
        const genderVal = genderFilter.value;
        const hairTypeVal = hairTypeFilter.value;

        let filteredItems = allItems;

        if (ageVal != '*') {
            filteredItems = filteredItems.filter(v => {
                return v.ageFilterVal.toLowerCase() == ageVal.toLowerCase();
            });
        }
        if (genderVal != '*') {
            filteredItems = filteredItems.filter(v => {
                return v.genderFilterVal.toLowerCase() == genderVal.toLowerCase();
            });
        }
        if (hairTypeVal != '*') {
            filteredItems = filteredItems.filter(v => {
                return v.hairType.toLowerCase() == hairTypeVal.toLowerCase();
            });
        }
        currentItemArray = filteredItems;
        resultsElement.innerHTML = filteredItems.length;
        buildItems(filteredItems);
        updateAmountShownElement();
    }

    const buildItems = arrOfItems => {
        itemListElement.innerHTML = '';

        if (arrOfItems.length <= 9) {
            loadMoreElement.classList.add('hidden');
        } else {
            loadMoreElement.classList.remove('hidden');
        }

        for (let i = 0; i < 9; i++) {
            if (!arrOfItems[i]) {
                break;
            }
            setupEventListenerForItem(arrOfItems[i], itemListElement)
        }
        updateProgressBar();
    }

    const setupEventListenerForItem = (item, itemList) => {
        let itemElement = document.createElement('div');
        itemElement.classList.add('ba__list__item');
        itemElement.innerHTML = buildBeforeAfterItem(item);
        itemElement.dataset.itemData = JSON.stringify(item);
        itemElement.addEventListener('click', () => {
            popupElement.querySelector('.js-content').innerHTML = buildBeforeAfterPopup(JSON.parse(itemElement.dataset.itemData));
            activatePopup();
        });
        itemListElement.appendChild(itemElement);
    }

    const updateProgressBar = () => {
        const progress = (itemListElement.querySelectorAll('.ba__list__item').length / currentItemArray.length * 100).toString() + '%';
        progressBarElement.style.width = progress;
    }

    const updateAmountShownElement = () => {
        amountShownElement.innerHTML = itemListElement.querySelectorAll('.ba__list__item').length;
        totalAmountElement.innerHTML = currentItemArray.length;
    }

    const activatePopup = () => {
        document.body.classList.add('lock-body');
        popupElement.classList.add('active');
        overlay.classList.add('active');
        const swiper = new Swiper('.swiper', {
            navigation: {
                nextEl: document.querySelector('.js-nav-next'),
                prevEl: document.querySelector('.js-nav-prev')
            }
        });
        let imagesToToggleLightbox = document.querySelectorAll('.js-toggle-lightbox');

        let lightboxContent = document.querySelector('.js-lightbox-content').innerHTML;
        imagesToToggleLightbox.forEach(img => {
            img.addEventListener('click', () => {
                let instance = basicLightbox.create(lightboxContent).show();
            });
        });
    }

    const deactivePopup = () => {
        document.body.classList.remove('lock-body');
        popupElement.classList.remove('active');
        overlay.classList.remove('active');
        popupElement.querySelector('.js-content').innerHTML = "";
    }

    /* Other init stuff yada yada */
    updateProgressBar();
    ageFilter.disabled = false;
    genderFilter.disabled = false;
    hairTypeFilter.disabled = false;
    resetFilter.disabled = false;
    itemListElement.querySelectorAll('.ba__list__item').forEach(element => {
        element.addEventListener('click', () => {
            popupElement.querySelector('.js-content').innerHTML = buildBeforeAfterPopup(JSON.parse(element.dataset.itemData));
            activatePopup();
        });
    });

    /* Util */
    const buildBeforeAfterItem = item => {
        return `
            <div class="ba__list__item__images">
                <div class="ba__list__item__images__image">
                    <div class="aspect-ratio-helper">
                        <img src="${item.imageBefore1}">
                    </div>
                    <p>Before</p>
                </div>
                <div class="ba__list__item__images__image">
                    <div class="aspect-ratio-helper">
                        <img src="${item.imageAfter1}">
                    </div>
                    <p>Now</p>
                </div>
            </div>
        `;
    }
    
    const buildBeforeAfterPopup = item => {
        return `
            <div class="js-lightbox-content">
            ${(() => {
                let el = ''
                if (item.imageBefore1.indexOf('no-image') == -1 && item.imageAfter1.indexOf('no-image') == -1) {
                    el = `
                        <div class="ba__popup__images">
                            <div class="ba__popup__image">
                                <div class="image-helper">
                                    <img src="${item.imageBefore1}">
                                </div>
                                <p>${baTranslations.before}</p>
                            </div>
                            <div class="ba__popup__image">
                                <div class="image-helper">
                                    <img src="${item.imageAfter1}">
                                </div>
                                <p>${baTranslations.after}</p>
                            </div>
                        </div>
                    `
                    return el;
                } else {
                    return '';
                }
            })()}
            ${(() => {
                let el = ''
                if (item.imageBefore2.indexOf('no-image') == -1 && item.imageAfter2.indexOf('no-image') == -1) {
                    el = `
                        <div class="ba__popup__images">
                            <div class="ba__popup__image">
                                <div class="image-helper">
                                    <img src="${item.imageBefore2}">
                                </div>
                                <p>${baTranslations.before}</p>
                            </div>
                            <div class="ba__popup__image">
                                <div class="image-helper">
                                    <img src="${item.imageAfter2}">
                                </div>
                                <p>${baTranslations.after}</p>
                            </div>
                        </div>
                    `
                    return el;
                } else {
                    return '';
                }
            })()}
            ${(() => {
                let el = ''
                if (item.imageBefore3.indexOf('no-image') == -1 && item.imageAfter3.indexOf('no-image') == -1) {
                    el = `
                        <div class="ba__popup__images">
                            <div class="ba__popup__image">
                                <div class="image-helper">
                                    <img src="${item.imageBefore3}">
                                </div>
                                <p>${baTranslations.before}</p>
                            </div>
                            <div class="ba__popup__image">
                                <div class="image-helper">
                                    <img src="${item.imageAfter3}">
                                </div>
                                <p>${baTranslations.after}</p>
                            </div>
                        </div>
                    `
                    return el;
                } else {
                    return '';
                }
            })()}
            ${(() => {
                let el = ''
                if (item.imageBefore4.indexOf('no-image') == -1 && item.imageAfter4.indexOf('no-image') == -1) {
                    el = `
                        <div class="ba__popup__images">
                            <div class="ba__popup__image">
                                <div class="image-helper">
                                    <img src="${item.imageBefore4}">
                                </div>
                                <p>${baTranslations.before}</p>
                            </div>
                            <div class="ba__popup__image">
                                <div class="image-helper">
                                    <img src="${item.imageAfter4}">
                                </div>
                                <p>${baTranslations.after}</p>
                            </div>
                        </div>
                    `
                    return el;
                } else {
                    return '';
                }
            })()}
            ${(() => {
                let el = ''
                if (item.imageBefore5.indexOf('no-image') == -1 && item.imageAfter5.indexOf('no-image') == -1) {
                    el = `
                        <div class="ba__popup__images">
                            <div class="ba__popup__image">
                                <div class="image-helper">
                                    <img src="${item.imageBefore5}">
                                </div>
                                <p>${baTranslations.before}</p>
                            </div>
                            <div class="ba__popup__image">
                                <div class="image-helper">
                                    <img src="${item.imageAfter5}">
                                </div>
                                <p>${baTranslations.after}</p>
                            </div>
                        </div>
                    `
                    return el;
                } else {
                    return '';
                }
            })()}
            ${(() => {
                let el = ''
                if (item.imageBefore6.indexOf('no-image') == -1 && item.imageAfter6.indexOf('no-image') == -1) {
                    el = `
                        <div class="ba__popup__images">
                            <div class="ba__popup__image">
                                <div class="image-helper">
                                    <img src="${item.imageBefore6}">
                                </div>
                                <p>${baTranslations.before}</p>
                            </div>
                            <div class="ba__popup__image">
                                <div class="image-helper">
                                    <img src="${item.imageAfter6}">
                                </div>
                                <p>${baTranslations.after}</p>
                            </div>
                        </div>
                    `
                    return el;
                } else {
                    return '';
                }
            })()}
            </div>
            <div class="ba__popup__top">
                <div class="swiper">
                    <button type="button" class="nav nav--prev js-nav-prev">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"/>
                    <polyline points="10 17.83 15.4 12.43 10 7.03"
                              style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:2px"/>
                    </svg>
                    </button>
                    <button type="button" class="nav nav--next js-nav-next">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"/>
                    <polyline points="10 17.83 15.4 12.43 10 7.03"
                              style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:2px"/>
                    </svg>                  
                    </button>
                    <div class="swiper-wrapper">
                        ${(() => {
                let el = ''
                if (item.imageBefore1.indexOf('no-image') == -1 && item.imageAfter1.indexOf('no-image') == -1) {
                    el = `
                                <div class="swiper-slide">
                                    <div class="ba__popup__images">
                                        <div class="ba__popup__image js-toggle-lightbox">
                                            <div class="image-helper">
                                                <img src="${item.imageBefore1}">
                                            </div>
                                            <p>${baTranslations.before}</p>
                                        </div>
                                        <div class="ba__popup__image js-toggle-lightbox">
                                            <div class="image-helper">
                                                <img src="${item.imageAfter1}">
                                            </div>
                                            <p>${baTranslations.after}</p>
                                        </div>
                                    </div>
                                </div>
                                `
                    return el;
                } else {
                    return '';
                }
            })()}
                        ${(() => {
                let el = ''
                if (item.imageBefore2.indexOf('no-image') == -1 && item.imageAfter2.indexOf('no-image') == -1) {
                    el = `
                                <div class="swiper-slide">
                                    <div class="ba__popup__images">
                                        <div class="ba__popup__image js-toggle-lightbox">
                                            <div class="image-helper">
                                                <img src="${item.imageBefore2}">
                                            </div>
                                            <p>${baTranslations.before}</p>
                                        </div>
                                        <div class="ba__popup__image js-toggle-lightbox">
                                            <div class="image-helper">
                                                <img src="${item.imageAfter2}">
                                            </div>
                                            <p>${baTranslations.after}</p>
                                        </div>
                                    </div>
                                </div>
                                `
                    return el;
                } else {
                    return '';
                }
            })()}
                        ${(() => {
                let el = ''
                if (item.imageBefore3.indexOf('no-image') == -1 && item.imageAfter3.indexOf('no-image') == -1) {
                    el = `
                                <div class="swiper-slide">
                                    <div class="ba__popup__images">
                                        <div class="ba__popup__image js-toggle-lightbox">
                                            <div class="image-helper">
                                                <img src="${item.imageBefore3}">
                                            </div>
                                            <p>${baTranslations.before}</p>
                                        </div>
                                        <div class="ba__popup__image js-toggle-lightbox">
                                            <div class="image-helper">
                                                <img src="${item.imageAfter3}">
                                            </div>
                                            <p>${baTranslations.after}</p>
                                        </div>
                                    </div>
                                </div>
                                `
                    return el;
                } else {
                    return '';
                }
            })()}
            ${(() => {
                let el = ''
                if (item.imageBefore4.indexOf('no-image') == -1 && item.imageAfter4.indexOf('no-image') == -1) {
                    el = `
                    <div class="swiper-slide">
                        <div class="ba__popup__images">
                            <div class="ba__popup__image">
                                <div class="image-helper">
                                    <img src="${item.imageBefore4}">
                                </div>
                                <p>${baTranslations.before}</p>
                            </div>
                            <div class="ba__popup__image">
                                <div class="image-helper">
                                    <img src="${item.imageAfter4}">
                                </div>
                                <p>${baTranslations.after}</p>
                            </div>
                        </div>
                    </div>
                    `
                    return el;
                } else {
                    return '';
                }
            })()}
            ${(() => {
                let el = ''
                if (item.imageBefore5.indexOf('no-image') == -1 && item.imageAfter5.indexOf('no-image') == -1) {
                    el = `
                    <div class="swiper-slide">
                        <div class="ba__popup__images">
                            <div class="ba__popup__image">
                                <div class="image-helper">
                                    <img src="${item.imageBefore5}">
                                </div>
                                <p>${baTranslations.before}</p>
                            </div>
                            <div class="ba__popup__image">
                                <div class="image-helper">
                                    <img src="${item.imageAfter5}">
                                </div>
                                <p>${baTranslations.after}</p>
                            </div>
                        </div>
                    </div>
                    `
                    return el;
                } else {
                    return '';
                }
            })()}
            ${(() => {
                let el = ''
                if (item.imageBefore6.indexOf('no-image') == -1 && item.imageAfter6.indexOf('no-image') == -1) {
                    el = `
                    <div class="swiper-slide">
                        <div class="ba__popup__images">
                            <div class="ba__popup__image">
                                <div class="image-helper">
                                    <img src="${item.imageBefore6}">
                                </div>
                                <p>${baTranslations.before}</p>
                            </div>
                            <div class="ba__popup__image">
                                <div class="image-helper">
                                    <img src="${item.imageAfter6}">
                                </div>
                                <p>${baTranslations.after}</p>
                            </div>
                        </div>
                    </div>
                    `
                    return el;
                } else {
                    return '';
                }
            })()}
                    </div>
                </div>
            </div>
            <div class="ba__popup__bottom">
                ${(() => {
                let el = ''
                if (item.description) {
                    el += `
                        <div style="text-align:${item.alignInfo};" class="ba__popup__bottom__description">
                            <p>${item.description}</p>
                        </div>
                        `
                }
                el += `<div style="text-align:${item.alignDesc};" class="ba__popup__bottom__info">`;
                if (item.title) {
                    el += `<p>${item.title}</p>`;
                }
                if (item.period) {
                    el += `<p>${baTranslations.period}: ${item.period}</p>`;
                }
                if (item.age) {
                    el += `<p>${baTranslations.age}: ${item.age}</p>`;
                }
                if (item.gender) {
                    el += `<p>${baTranslations.gender}: ${item.gender}</p>`;
                }
                if (item.hairType) {
                    el += `<p>${baTranslations.hairType}: ${item.hairType}</p>`;
                }
                el += '</div>';
                return el;
            })()}
            </div>
        `;
    }
    
    const init = function() {
        const amountOfItemsCurrentlyLoaded = itemListElement.querySelectorAll('.ba__list__item').length;

        for (let i = amountOfItemsCurrentlyLoaded; i < amountOfItemsCurrentlyLoaded + 18; i++) {
            if (i == currentItemArray.length) {
                loadMoreElement.classList.add('hidden');
                break;
            }
            setupEventListenerForItem(currentItemArray[i], itemListElement)
        }
        updateProgressBar();
        updateAmountShownElement();
    }

    init();

})()